import { Component, OnInit } from '@angular/core';
import { AnnouncementService } from './shared/services/announcement.service';
import { Announcement } from './shared/models/announcement';

@Component({
	selector: 'kpa-announcements',
	templateUrl: './announcements.component.html',
	styleUrl: './announcements.component.scss',
})
export class AnnouncementsComponent implements OnInit {
	public isDashboard: boolean = false;
	public announcements: Announcement[] = [];

	constructor(private announcementService: AnnouncementService) {}
	ngOnInit() {
		this.announcementService.getRSSSystemList().subscribe((result: Announcement[]) => {
			this.announcements = result;
		});
	}
}
